import { render, staticRenderFns } from "./YampiOauth.vue?vue&type=template&id=e5510982&scoped=true&"
import script from "./YampiOauth.vue?vue&type=script&lang=js&"
export * from "./YampiOauth.vue?vue&type=script&lang=js&"
import style0 from "./YampiOauth.vue?vue&type=style&index=0&id=e5510982&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5510982",
  null
  
)

export default component.exports